import React from "react";
import { Box, Typography } from "@mui/material";

import MobileAppShell from "../../layout/MobileAppShell";
import RecentAttemptsAnalytics from "../../components/RecentAttemptsAnalytics";
import BatchSelector from "../../components/BatchSelector";
import { useSelectedBatch } from "../../hooks";
import AttemptedAssessments from "./AttemptedAssessments";

/**
 * Mobile Performance page — the mobile equivalent of the desktop
 * `/:client/performance` route (screens/Performance.jsx -> OverallPerformance).
 *
 * Loads the active batch and feeds it to both sections:
 *   1. Recent Attempts Analytics (with the 12/24/36 range toggle here).
 *   2. Your attempted assessments (paginated list).
 */
export default function MobilePerformance() {
  const { batches, batchData, loading, selectBatch } = useSelectedBatch();
  const batchId = batchData?._id;

  return (
    <MobileAppShell title="Performance">
      <Box sx={{ px: 4, py: 4, display: "flex", flexDirection: "column", gap: 5 }}>
        {/* Page header band */}
        <Typography
          variant="h6-bold"
          color="primary.clr-300"
          sx={{
            pb: 2,
            borderBottom: "2px solid",
            borderColor: "primary.clr-300",
          }}
        >
          Performance
        </Typography>

        {/* Batch picker — drives both sections below it */}
        <BatchSelector
          batches={batches}
          value={batchData}
          onChange={selectBatch}
          loading={loading}
        />

        <RecentAttemptsAnalytics
          batch={batchId}
          batchLoading={loading}
          showRangeToggle
        />

        <AttemptedAssessments batch={batchId} batchLoading={loading} />
      </Box>
    </MobileAppShell>
  );
}
